import { ContextMenu } from "lib/@components/context-menu-bar"

export const GroupContextMenu = ContextMenu("group")
export const ReferenceContextMenu = ContextMenu("reference")
